// Coach names may carry credentials after a comma, e.g. "Sheldon Cadoy, PGA".
export const splitFullName = fullName => {
  const personalName = (typeof fullName === 'string' ? fullName : '')
    .split(',')[0]
    .trim()
  const words = personalName.split(/\s+/).filter(Boolean)

  return {
    firstName: words.slice(0, -1).join(' '),
    lastName: words.slice(-1).join(' '),
  }
}
